exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-bar{position:fixed;top:0;left:0;z-index:998;background:#42b983;box-shadow:0 2px 5px 0 rgba(0,0,0,.26);overflow:hidden}.app-bar,.app-bar-wrapper{width:100%;height:3.625rem}.app-bar-wrapper .arrow,.app-bar-wrapper .menu{float:left;padding:0;width:3.625rem;height:3.625rem;border:none;color:#fff;outline:none;cursor:pointer;background-color:transparent}.app-bar-wrapper .menu{font-size:1.3rem}.app-bar-wrapper .arrow{font-size:1rem}.app-bar-wrapper h1{float:left;margin:0;font-size:1.25rem;font-weight:300;line-height:2.8em;color:#fefefe}.app-bar-wrapper .add,.app-bar-wrapper .more{float:right;padding:0;width:3.625rem;height:3.625rem;border:none;color:#fff;outline:none;cursor:pointer;background-color:transparent;margin-right:.1em;font-size:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-50cca722","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/appBar.vue
// module id = 24
// module chunks = 0